export const wlaMonitorLoader = {
  listMonitor: 'listMonitor',
  cardMonitor: 'cardMonitor',
  detailMonitor: 'detailMonitor',
};

export const initialStateMonitor = {
  listMonitor: true,
  cardMonitor: true,
  detailMonitor: true,
};
